import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";
export type NotificationsDTO =  {
    id: string,
    title: string,
    message: string,
    type: string,
    from: string,
    isRead: boolean,
    createdAt: string,
    updatedAt: string
}

interface NotificationsResponse {
    data?: NotificationsDTO[];
    error?: ApiError;
}

export const GetAllNotificationsStudent = async (): Promise<NotificationsResponse> => {
    try {
        const response = await axios.get("/notification/notifications-student");
            return { data: response.data };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};
export const GetAllNotificationsAdmin = async (): Promise<NotificationsResponse> => {
    try {
        const response = await axios.get("/notification/notifications-admin");
            return { data: response.data };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error: any) {
        console.error("API Error:", error);
        if (error.response) {
            const apiError: ApiError = {
                statusCode: error.response.status,
                message: error.response.data.message,
                error: error.response.data.error,
            };
            return { error: apiError };
        } else {
            const fallbackError: ApiError = {
                statusCode: 500,
                message: "An unexpected error occurred",
            };
            return { error: fallbackError };
        }
    }
};